import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { profile } from "../../data/profile";
import { NAV_ITEMS, SOCIAL_ICONS } from "./nav";

const Sidebar = ({ collapsed, onToggleCollapse, mobileOpen, onCloseMobile }) => {
  return (
    <>
      <div
        className={`sidebar-overlay${mobileOpen ? " is-visible" : ""}`}
        onClick={onCloseMobile}
        aria-hidden="true"
      />
      <aside
        className={`sidebar${collapsed ? " is-collapsed" : ""}${
          mobileOpen ? " is-mobile-open" : ""
        }`}
      >
        <div className="sidebar-top">
          <NavLink to="/" className="brand" onClick={onCloseMobile}>
            <span className="brand-mark">{"</>"}</span>
            <span className="brand-text">
              rksharma<span className="brand-accent">.in</span>
            </span>
          </NavLink>
          <button
            type="button"
            className="icon-btn sidebar-close"
            onClick={onCloseMobile}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `sidebar-link${isActive ? " is-active" : ""}`
              }
              onClick={onCloseMobile}
              title={label}
            >
              <span className="sidebar-link-icon">
                <Icon />
              </span>
              <span className="sidebar-link-label">{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-foot">
          <div className="sidebar-socials">
            {profile.socials.map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              return (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-btn"
                  aria-label={s.label}
                  title={s.label}
                >
                  {Icon && <Icon />}
                </a>
              );
            })}
          </div>
          <button
            type="button"
            className="icon-btn sidebar-collapse"
            onClick={onToggleCollapse}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand" : "Collapse"}
          >
            {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
